import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

const SURI_SDK_ID = 'cbm-jssdk';
const SURI_SDK_URL = 'https://webchat.chatbotmaker.io/cbm-jssdk.js';

interface SuriWebChatSdk {
  ChatbotId: string;
  StartWebChat: (
    user?: object,
    showPopup?: boolean,
    elementId?: string
  ) => Promise<unknown>;
}

declare const CBM: SuriWebChatSdk;

declare global {
  interface Window {
    cbAsyncInit?: () => void;
  }
}

@Component({
  selector: 'app-suri-webchat',
  template: '',
})
export class SuriWebchatComponent implements OnInit {
  constructor(@Inject(DOCUMENT) private document: Document) {}

  ngOnInit(): void {
    const chatbotId = environment.suriWebchatId;

    if (!chatbotId) {
      return;
    }

    window.cbAsyncInit = () => {
      CBM.ChatbotId = chatbotId;
      CBM.StartWebChat(undefined, false, undefined).catch((reason) => {
        console.error('Não foi possível iniciar o Webchat Suri.', reason);
      });
    };

    if (typeof CBM !== 'undefined') {
      window.cbAsyncInit();
      return;
    }

    if (this.document.getElementById(SURI_SDK_ID)) {
      return;
    }

    const script = this.document.createElement('script');
    script.id = SURI_SDK_ID;
    script.src = SURI_SDK_URL;
    script.async = true;
    this.document.body.appendChild(script);
  }
}
